var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.uploadWidget)?_c('div',{staticClass:"civii-upload"},[_c('input',{ref:"upload",attrs:{"type":"file","accept":"image/png,image/jpeg"}}),_vm._v(" "),_c('cancelaccept',{staticClass:"cancelaccept",on:{"accept":_vm.accept,"cancel":_vm.cancel}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5316ab64","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/UploadWidget/UploadWidget.vue
// module id = null
// module chunks = 